module.exports = __webpack_public_path__ + "static/media/derekchen.6e7ddb1c.jpg";